import { useState } from "react";
import { faqItems } from "@/mocks/cg51";
import { Reveal, SectionHeading } from "./ui";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-12">
          {/* 左：信任卡（醒目） */}
          <Reveal>
            <div className="flex h-full flex-col justify-between overflow-hidden rounded-lg border border-background-200 bg-primary-500 p-7 text-background-50 md:p-9">
              <div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-3 py-1.5 text-xs font-semibold">
                  <i className="ri-verified-badge-fill" /> cg51 使用指南
                </span>
                <h2 className="mt-5 font-heading text-2xl font-bold leading-snug md:text-3xl">怎么逛最省力？<br />几个常见疑问先答给你</h2>
                <p className="mt-4 text-sm leading-relaxed text-background-50/85">
                  我们把栏目的用法、更新的节奏和热度的算法都摊开来讲，让你不用猜也能快速上手，按兴趣直达你想看的分区与话题大全。
                </p>
              </div>
              <div className="mt-8 grid grid-cols-3 gap-3 border-t border-background-50/20 pt-6">
                {[
                  { v: "8", l: "内容分区" },
                  { v: "460+", l: "合集存档" },
                  { v: "24h", l: "持续更新" },
                ].map((s) => (
                  <div key={s.l} className="text-center">
                    <p className="font-heading text-xl font-black md:text-2xl">{s.v}</p>
                    <p className="mt-1 text-xs text-background-50/80">{s.l}</p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>

          {/* 右：手风琴 FAQ */}
          <Reveal delay={100}>
            <div className="flex h-full flex-col gap-3">
              {faqItems.map((item, idx) => {
                const open = openIdx === idx;
                return (
                  <div key={item.q} className={`overflow-hidden rounded-lg border transition-colors ${open ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50/60"}`}>
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? null : idx)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className={`text-sm font-semibold md:text-base ${open ? "text-primary-800" : "text-foreground-950"}`}>{item.q}</span>
                      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"}`}>
                        <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base`} />
                      </span>
                    </button>
                    <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                      <div className="overflow-hidden">
                        <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{item.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}